import type { SystemStyleObject } from "@ecco/ui/types";
import { scrollbarStyles } from "@ecco/ui/css/scrollbar";
import type { BoxProps } from "@ecco/ui/box";

export const motionBoxProps: BoxProps = {
    px: 4,
    py: 2,
    position: "absolute",
    backgroundColor: "white",
    marginTop: ["94px", "102px"],
    zIndex: 5,
    border: 1,
    borderColor: "gray.200",
    w: "100%",
    transition: "height 0.5s cubic-bezier(0.33, 1, 0.68, 1), visibility 0s",
};

export const styles: Record<string, SystemStyleObject> = {
    fieldWrapper: {
        position: "relative",
        flexDirection: "column",
        gap: 2,
    },
    addressesWrapper: {
        flexDirection: "column",
        gap: 2,
        height: "309px",
        overscrollBehavior: "contain",
        ...scrollbarStyles,
        overflowY: "auto",
        overflowX: "hidden",
        msOverflowStyle: "none",
        scrollbarWidth: "thin transparent",
        "::-webkit-scrollbar": { width: "4px", height: "2px" },
        "::-webkit-scrollbar-thumb": {
            background: "black",
            borderRadius: "5px",
        },
        "::-webkit-scrollbar-track": {
            background: "gray.200",
            borderRadius: "5px",
        },
    },
    addressButton: {
        h: ["unset"],
        p: [0, 0, 0, 0],
        whiteSpace: "pre-line",
        textAlign: "justify",
        fontSize: ["mobileBodyB2", "desktopBodyB2"],
    },
    divider: {
        mt: 2,
    },
    tooltip: {
        backgroundColor: "gray.800",
        py: 7,
        px: 4,
        whiteSpace: "pre-line",
    },
    tooltipContentWrapper: {
        gap: 2,
        alignItems: "center",
        w: "fit-content",
    },
    tooltipText: {
        fontSize: "mobileBodyB4",
        pl: 2,
        color: "red.500",
    },
    noAddressesText: {
        position: "relative",
        fontWeight: "bold",
        top: "50%",
        transform: "translateY(-50%)",
    },
    progress: {
        top: "50%",
        transform: "translateY(-50%)",
    },
};
